import { denormalize, normalize } from 'normalizr'
import { useSelector } from 'react-redux'
import api from '../../api'
import createSlice from '../create-slice'
import { practicesSchema, featureFlagsSchema } from '../normalizr'
import { getEntities } from './entities'

const initialState = {
  practicesIds: [],
  featureFlagsIds: [],
}

const practiceFeaturesSlice = createSlice({
  name: 'practiceFeatures',
  initialState,
  reducers: {
    setPractices: (state, { payload }) => {
      state.practicesIds = payload.result
    },
    setFeatureFlags: (state, { payload }) => {
      state.featureFlagsIds = payload.result
    },
  },
})

const { actions } = practiceFeaturesSlice

const selectState = state => state[practiceFeaturesSlice.name]

export function usePracticeFeatures() {
  const { practicesIds, featureFlagsIds } = useSelector(selectState)
  const entities = useSelector(getEntities)

  return {
    practices: denormalize(practicesIds || [], [practicesSchema], entities),
    featureFlags: denormalize(
      featureFlagsIds || [],
      [featureFlagsSchema],
      entities,
    ),
  }
}

export function fetchPracticeFeatures() {
  return async dispatch => {
    const [{ body: practices }, featureFlags] = await Promise.all([
      api.practices.getPractices(),
      api.featureFlags.list(),
    ])

    dispatch(actions.setPractices(normalize(practices, [practicesSchema])))
    dispatch(
      actions.setFeatureFlags(normalize(featureFlags, [featureFlagsSchema])),
    )
  }
}

export function toggleFeatureFlag(practiceId, featureFlagId, enabled) {
  return api.featureFlags[enabled ? 'attach' : 'detach'](
    featureFlagId,
    practiceId,
  )
}

export default practiceFeaturesSlice
